import {
  Box,
  SkeletonGroup,
  SkeletonLine,
  SkeletonRectangle,
} from '@wix/design-system';
import { FC } from 'react';

const AboutSkeletonMobile: FC = () => {
  return (
    <SkeletonGroup>
      <Box direction="vertical" gap="36px" width="100%">
        <Box direction="vertical" gap="6px">
          <SkeletonLine />
          <SkeletonLine />
          <SkeletonLine width="70%" />
        </Box>
        <Box direction="vertical" gap="12px">
          <SkeletonRectangle height="155px" />
          <SkeletonRectangle height="144px" />
        </Box>
      </Box>
    </SkeletonGroup>
  );
};

export default AboutSkeletonMobile;
